import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {Button} from '../../../../basic-ui-components/button/base/button.component';

export const StateSelectorButtonComponent = observer(class StateSelectorButtonComponent extends OrbitComponent {

    handleClick(){
       //this.services.analytics.sendAnalytics("Navigation", "Header", "State Selector");
        this.services.stateOfResidenceIdentifier.displayStateSelectorPopup({
            forceDisplay: true
        });
    }

    render() {
        let icon;
        let currentState = this.services.stateOfResidenceIdentifier.getUserSelectedState();
        if (currentState) {
            icon = <this.services.theme.currentTheme.icons.twoCharsIcon text={currentState.toUpperCase()} sizeIsHeight/>
        } else {
            icon = <this.services.theme.currentTheme.icons.usaMapIcon style={{color: this.services.theme.currentTheme.colors.brandPrimary}}/>;
        }

        return (
            <Button
                className={"cy-header-state-selector-button"}
                preset="flatStroked"
                onClick={this.handleClick.bind(this)}
                margin="0.4rem 0.4rem"
                sizeVariant={this.services.device.isMobile ? "xs" : "m"}
                >
                {icon}
            </Button>
        );
    }
});
